import React from "react";
import { connect } from "react-redux";
import { actions as bridgeActions } from "../../../redux/bridge";

const EXPLORE_ACTIVATE_ASSET_SUCCESS = "activate/asset/success";
const EXPLORE_RETURN_ASSET_SUCCESS = "return/asset/success";
const EXPLORE_FETCH_SESSION_SUCCESS = "get/user/credits/success";

class SyncListeners extends React.Component {
  constructor(props) {
    super(props);
    this.dispatchEvent = this.dispatchEvent.bind(this);
  }

  componentDidMount() {
    window.addEventListener("explore-data-update", this.dispatchEvent, {
      capture: true
    });
  }

  componentWillUnmount() {
    window.removeEventListener("explore-data-update", this.dispatchEvent, {
      capture: true
    });
  }

  dispatchEvent(e) {
    const action = e.detail;
    e.stopPropagation();
    switch (action.type) {
      case EXPLORE_FETCH_SESSION_SUCCESS: {
        this.props.dispatch(bridgeActions.syncFetchSessionSuccess(action.data));
        break;
      }
      case EXPLORE_ACTIVATE_ASSET_SUCCESS: {
        this.props.dispatch(
          bridgeActions.syncActivateAssetSuccess(action.vbid, action.asset)
        );
        break;
      }
      case EXPLORE_RETURN_ASSET_SUCCESS: {
        this.props.dispatch(
          bridgeActions.syncReturnAssetSuccess(action.vbid, action.asset)
        );
        break;
      }
      default: {
        // do nothing
      }
    }
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(null, mapDispatchToProps)(SyncListeners);
